<template>
<div class="RlistM">
  <div
    class="cardR"
     v-for="item in Transtions"
    :key="item.title"
    @click="showdialog(item)"
  >
  <div class="Rlist">
    <v-list subheader>
      <v-list-item class="del">
        <v-list-item-avatar class="maf">
            <v-img v-if="item.activity == 2" :src="require('../assets/frsc.png')"></v-img>
            <v-img  v-else-if="item.activity == 3" :src="require('../assets/transfer.png')"></v-img>
            <v-img  v-else-if="item.activity == 4" :src="require('../assets/NIS.png')"></v-img>
            <v-img  v-else-if="item.activity == 5" :src="require('../assets/teller.png')"></v-img>
            <v-img  v-else-if="item.activity == 6" :src="require('../assets/bank.png')"></v-img>
            <v-img  v-else-if="item.activity == 7" :src="require('../assets/transfer.png')"></v-img>
            <v-img  v-else-if="item.activity == 8" :src="require('../assets/jamb.png')"></v-img>
            <v-img  v-else-if="item.activity == 9" :src="require('../assets/elect.png')"></v-img>
            <v-img  v-else-if="item.activity == 10" :src="require('../assets/airTime.png')"></v-img>
            <v-img  v-else-if="item.activity == 11" :src="require('../assets/cable.png')"></v-img>
            <v-img  v-else-if="item.activity == 12" :src="require('../assets/net.png')"></v-img>
            <v-img  v-else-if="item.activity == 13" :src="require('../assets/moneytransfer.png')"></v-img>
            <v-img  v-else-if="item.activity == 14" :src="require('../assets/teller.png')"></v-img>
            <v-img v-else :src="require('../assets/teller.png')"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
         <v-list-item-title class="lis" v-if="item.activity == 2">FRSC Driver's License</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 3">REVERSAL</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 4">NIS Payment</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 5">MANUAL CREDIT</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 6">BANK TRANSFER DEPOSIT</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 7">BANK TRANSFER WITHDRAWAL</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 8">JAMB Payment</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 9">ELECTRICITY</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 10">AIRTIME Purchase - MTN {{item.network}}</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 11">CABLE (TV)</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 12">INTERNET</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 13"> PERSONAL TRANSFER</v-list-item-title>
        <v-list-item-title class="lis" v-else-if="item.activity == 14"> POS CREDIT</v-list-item-title>
        <v-list-item-title class="lis" v-else>View Details</v-list-item-title>
        <v-list-item-title class="tim"> {{DisplayTime(item.timestamp)}} </v-list-item-title>
        </v-list-item-content>
         <v-list-item-icon class="mon"> {{DisplayCurrency(item.amount/100)}} </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
  </div>
        <v-dialog v-model="dialog" width="600px">
             <v-card>
        <v-card-title>
          <span class="headline">Transaction Details</span>
        </v-card-title>
        <v-card-text>
          <span v-if="detail.additional">Reference ID: {{detail.additional.referenceId}}</span>
          <br>
          <span v-if="detail.timestamp">Date: {{DisplayTime(detail.timestamp)}}</span>
          <br>
          <span v-if="detail.timestamp">Amount: {{DisplayCurrency(detail.amount/100)}}</span>
          <br>
           <span v-if="detail.timestamp">Balance After Transaction: {{DisplayCurrency(detail.mainBalanceAfterTransaction/100)}}</span>
          <br>
           <span v-if="detail.timestamp">Commission Balance After Transaction: {{DisplayCurrency(detail.commissionBalanceAfterTransaction/100)}}</span>
          <br>
        </v-card-text>
           <v-card-title>
          <span class="headline">Additional Info</span>
        </v-card-title>
        <v-card-text v-if="detail.additional">
        <span v-if="detail.additional.tvNetwork">TV Network: {{detail.additional.tvNetwork}}</span>
          <br v-if="detail.additional.tvNetwork">
        <span v-if="detail.additional.reference">Reference: {{detail.additional.reference}}</span>
          <br v-if="detail.additional.reference">
        <span v-if="detail.additional.mobileNumber">Mobile Number: {{detail.additional.mobileNumber}}</span>
          <br v-if="detail.additional.mobileNumber">
        <span v-if="detail.additional.destBank">Bank: {{detail.additional.destBank}}</span>
          <br v-if="detail.additional.destBank">
        <span v-if="detail.additional.accountNumber">Account Number: {{detail.additional.accountNumber}}</span>
          <br v-if="detail.additional.accountNumber">
        <span v-if="detail.additional.accountName">Account Name: {{detail.additional.accountName}}</span>
          <br v-if="detail.additional.accountName">

           <span v-if="detail.additional.appID">App ID: {{detail.additional.appID}}</span>
          <br v-if="detail.additional.appID">
           <span v-if="detail.additional.payBillTxnID">TxnID: {{detail.additional.payBillTxnID}}</span>
          <br v-if="detail.additional.payBillTxnID">
           <span v-if="detail.additional.applicantFirstname">FullName: {{detail.additional.applicantFirstname}} {{detail.additional.applicantLastname}}</span>
          <br v-if="detail.additional.applicantFirstname">
          <span v-if="detail.additional.candidateFirstName">Candidate Name: {{detail.additional.candidateFirstName}} {{detail.additional.candidateLastName}}</span>
          <br v-if="detail.additional.candidateFirstName">
           <span v-if="detail.additional.pin">Pin: {{detail.additional.pin}}</span>
          <br v-if="detail.additional.pin">
           <span v-if="detail.additional.confirmationCode">Confirmation Code: {{detail.additional.confirmationCode}}</span>
          <br v-if="detail.additional.confirmationCode">
             <span v-if="detail.additional.meterToken">Meter Token: {{detail.additional.meterToken}}</span>
          <br v-if="detail.additional.meterToken">
            <span v-if="detail.additional.units">Units: {{detail.additional.units}}</span>
          <br v-if="detail.additional.units">
            <span v-if="detail.additional.accountFrom">From: {{detail.additional.accountFrom}}</span>
          <br v-if="detail.additional.accountFrom">
          <span v-if="detail.additional.accountTo">To: {{detail.additional.accountTo}}</span>
          <br v-if="detail.additional.accountTo">

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">Okay</v-btn>
        </v-card-actions>
      </v-card>
        </v-dialog>
</div>
</template>
<script>
import currencyFormatter from 'currency-formatter'
import dayjs from "dayjs";

export default {
     data: () => ({
          dialog:false,
          detail:{}
    }),
     created() {
      this.GetTranstion()
    },
      computed: {
       Transtions() {
            return this.$store.state.Transactions.Transtions;
          },
          User () {
        return this.$store.getters.getUser
        },
    },
    methods: {
      showdialog(payload){
        this.dialog= true
        this.detail= payload
      },
      GetTranstion(){
          let payload = {
          pin: this.User.pin,
          customerID: this.User.customerID,
      }
        this.$store.dispatch('LoadTranstions', payload)
        this.$store.dispatch('getCableBundle')
      },

      DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    DisplayTime(payload){
    if (payload) {
      return dayjs(payload).format('DD/MM/YYYY')
    }
  }
    },
}
</script>
<style scoped>
.cardR{
    margin: 10px;
    margin-left: 20px;
    margin-right: 20px;
     border-radius: 10px;
    box-shadow: 0 12px 40px 0 rgba(189, 36, 39, 0.1);
    background-color: #ffffff;

}
.tim{
  font-family: AvenirLTPro-45;
   font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.2;
  letter-spacing: normal;
  color: #000000;
}
.lis{
  font-family: 'AvenirLTProBook' !important;
  width: 136px;
  height: 22px;
  font-family: AvenirLTPro-95;
  font-size: 12px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #000000;
    text-transform: uppercase !important;
}
.RlistM{
    overflow: scroll;
}
.RlistM::-webkit-scrollbar {
  display: none;
}
.maf{
    margin-right: 4px;
}
.mon{
   font-family: AvenirLTPro-55Roman;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #444444;
}
.del{
  cursor: pointer;
}
</style>